import { render, staticRenderFns } from "./jdactivity.vue?vue&type=template&id=0cc9ae12&"
import script from "./jdactivity.vue?vue&type=script&lang=js&"
export * from "./jdactivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports